/***********************************************************/
/* Copyright (C) 1997 AT&T Bell Labs.  All rights reserved. */
/***********************************************************/
/* abstract syntax = csta_asn_tbl */
/* last module in input = CSTA-route-end-request-invoke */
/* created = Fri Aug  1 10 =51 =26 1997 */
/* associated control file = cstadefs.c */

// typedef char Boolean;
// typedef int  _Int;
// typedef char Nulltype;

export default {
  STATE_LOGOUT: 0,
  STATE_LOGIN: 1,
  STATE_READY: 2,
  STATE_NREADY: 3,
  STATE_DELIVERED_RECV: 4,
  STATE_DELIVERED_SEND: 5,
  STATE_DELIVERED_CONSULT: 6,
  STATE_ESTABLISHED: 7,
  STATE_ESTABLISHED_CONSULT: 8,
  STATE_HOLD: 9,
  STATE_CONFERENCED: 10,
  STATE_SERVICE_INITIATED: 11,
  STATE_ORIGINATED_COUNT1: 12,
  STATE_ORIGINATED_COUNT2: 13,
  CSTA_ALTERNATE_CALL: 1,
  CSTA_ALTERNATE_CALL_CONF: 2,
  CSTA_ANSWER_CALL: 3,
  CSTA_ANSWER_CALL_CONF: 4,
  CSTA_CALL_COMPLETION: 5,
  CSTA_CALL_COMPLETION_CONF: 6,
  CSTA_CLEAR_CALL: 7,
  CSTA_CLEAR_CALL_CONF: 8,
  CSTA_CLEAR_CONNECTION: 9,
  CSTA_CLEAR_CONNECTION_CONF: 10,
  CSTA_CONFERENCE_CALL: 11,
  CSTA_CONFERENCE_CALL_CONF: 12,
  CSTA_CONSULTATION_CALL: 13,
  CSTA_CONSULTATION_CALL_CONF: 14,
  CSTA_DEFLECT_CALL: 15,
  CSTA_DEFLECT_CALL_CONF: 16,
  CSTA_PICKUP_CALL: 17,
  CSTA_PICKUP_CALL_CONF: 18,
  CSTA_GROUP_PICKUP_CALL: 19,
  CSTA_GROUP_PICKUP_CALL_CONF: 20,
  CSTA_HOLD_CALL: 21,
  CSTA_HOLD_CALL_CONF: 22,
  CSTA_MAKE_CALL: 23,
  CSTA_MAKE_CALL_CONF: 24,
  CSTA_MAKE_PREDICTIVE_CALL: 25,
  CSTA_MAKE_PREDICTIVE_CALL_CONF: 26,
  CSTA_QUERY_MWI: 27,
  CSTA_QUERY_MWI_CONF: 28,
  CSTA_QUERY_DND: 29,
  CSTA_QUERY_DND_CONF: 30,
  CSTA_QUERY_FWD: 31,
  CSTA_QUERY_FWD_CONF: 32,
  CSTA_QUERY_AGENT_STATE: 33,
  CSTA_QUERY_AGENT_STATE_CONF: 34,
  CSTA_QUERY_LAST_NUMBER: 35,
  CSTA_QUERY_LAST_NUMBER_CONF: 36,
  CSTA_QUERY_DEVICE_INFO: 37,
  CSTA_QUERY_DEVICE_INFO_CONF: 38,
  CSTA_RECONNECT_CALL: 39,
  CSTA_RECONNECT_CALL_CONF: 40,
  CSTA_RETRIEVE_CALL: 41,
  CSTA_RETRIEVE_CALL_CONF: 42,
  CSTA_SET_MWI: 43,
  CSTA_SET_MWI_CONF: 44,
  CSTA_SET_DND: 45,
  CSTA_SET_DND_CONF: 46,
  CSTA_SET_FWD: 47,
  CSTA_SET_FWD_CONF: 48,
  CSTA_SET_AGENT_STATE: 49,
  CSTA_SET_AGENT_STATE_CONF: 50,
  CSTA_TRANSFER_CALL: 51,
  CSTA_TRANSFER_CALL_CONF: 52,
  CSTA_UNIVERSAL_FAILURE_CONF: 53,
  CSTA_CALL_CLEARED: 54,
  CSTA_CONFERENCED: 55,
  CSTA_CONNECTION_CLEARED: 56,
  CSTA_DELIVERED: 57,
  CSTA_DIVERTED: 58,
  CSTA_ESTABLISHED: 59,
  CSTA_FAILED: 60,
  CSTA_HELD: 61,
  CSTA_NETWORK_REACHED: 62,
  CSTA_ORIGINATED: 63,
  CSTA_QUEUED: 64,
  CSTA_RETRIEVED: 65,
  CSTA_SERVICE_INITIATED: 66,
  CSTA_TRANSFERRED: 67,
  CSTA_CALL_INFORMATION: 68,
  CSTA_DO_NOT_DISTURB: 69,
  CSTA_FORWARDING: 70,
  CSTA_MESSAGE_WAITING: 71,
  CSTA_LOGGED_ON: 72,
  CSTA_LOGGED_OFF: 73,
  CSTA_NOT_READY: 74,
  CSTA_READY: 75,
  CSTA_WORK_NOT_READY: 76,
  CSTA_WORK_READY: 77,
  CSTA_ROUTE_REGISTER_REQ: 78,
  CSTA_ROUTE_REGISTER_REQ_CONF: 79,
  CSTA_ROUTE_REGISTER_CANCEL: 80,
  CSTA_ROUTE_REGISTER_CANCEL_CONF: 81,
  CSTA_ROUTE_REGISTER_ABORT: 82,
  CSTA_ROUTE_REQUEST: 83,
  CSTA_ROUTE_SELECT_REQUEST: 84,
  CSTA_RE_ROUTE_REQUEST: 85,
  CSTA_ROUTE_USED: 86,
  CSTA_ROUTE_END: 87,
  CSTA_ROUTE_END_REQUEST: 88,
  CSTA_ESCAPE_SVC: 89,
  CSTA_ESCAPE_SVC_CONF: 90,
  CSTA_ESCAPE_SVC_REQ: 91,
  CSTA_ESCAPE_SVC_REQ_CONF: 92,
  CSTA_PRIVATE: 93,
  CSTA_PRIVATE_STATUS: 94,
  CSTA_SEND_PRIVATE: 95,
  CSTA_BACK_IN_SERVICE: 96,
  CSTA_OUT_OF_SERVICE: 97,
  CSTA_REQ_SYS_STAT: 98,
  CSTA_SYS_STAT_REQ_CONF: 99,
  CSTA_SYS_STAT_START: 100,
  CSTA_SYS_STAT_START_CONF: 101,
  CSTA_SYS_STAT_STOP: 102,
  CSTA_SYS_STAT_STOP_CONF: 103,
  CSTA_CHANGE_SYS_STAT_FILTER: 104,
  CSTA_CHANGE_SYS_STAT_FILTER_CONF: 105,
  CSTA_SYS_STAT: 106,
  CSTA_SYS_STAT_ENDED: 107,
  CSTA_SYS_STAT_REQ: 108,
  CSTA_REQ_SYS_STAT_CONF: 109,
  CSTA_SYS_STAT_EVENT_SEND: 110,
  CSTA_MONITOR_DEVICE: 111,
  CSTA_MONITOR_CALL: 112,
  CSTA_MONITOR_CALLS_VIA_DEVICE: 113,
  CSTA_MONITOR_CONF: 114,
  CSTA_CHANGE_MONITOR_FILTER: 115,
  CSTA_CHANGE_MONITOR_FILTER_CONF: 116,
  CSTA_MONITOR_STOP: 117,
  CSTA_MONITOR_STOP_CONF: 118,
  CSTA_MONITOR_ENDED: 119,
  CSTA_SNAPSHOT_CALL: 120,
  CSTA_SNAPSHOT_CALL_CONF: 121,
  CSTA_SNAPSHOT_DEVICE: 122,
  CSTA_SNAPSHOT_DEVICE_CONF: 123,
  CSTA_GETAPI_CAPS: 124,
  CSTA_GETAPI_CAPS_CONF: 125,
  CSTA_GET_DEVICE_LIST: 126,
  CSTA_GET_DEVICE_LIST_CONF: 127,
  CSTA_QUERY_CALL_MONITOR: 128,
  CSTA_QUERY_CALL_MONITOR_CONF: 129,
  CSTA_ROUTE_REQUEST_EXT: 130,
  CSTA_ROUTE_USED_EXT: 131,
  CSTA_ROUTE_SELECT_INV_REQUEST: 132,
  CSTA_ROUTE_END_INV_REQUEST: 133,

  // enum
  CSTAUniversalFailure: {
    GENERIC_UNSPECIFIED: 0,
    GENERIC_OPERATION: 1,
    REQUEST_INCOMPATIBLE_WITH_OBJECT: 2,
    VALUE_OUT_OF_RANGE: 3,
    OBJECT_NOT_KNOWN: 4,
    INVALID_CALLING_DEVICE: 5,
    INVALID_CALLED_DEVICE: 6,
    INVALID_FORWARDING_DESTINATION: 7,
    PRIVILEGE_VIOLATION_ON_SPECIFIED_DEVICE: 8,
    PRIVILEGE_VIOLATION_ON_CALLED_DEVICE: 9,
    PRIVILEGE_VIOLATION_ON_CALLING_DEVICE: 10,
    INVALID_CSTA_CALL_IDENTIFIER: 11,
    INVALID_CSTA_DEVICE_IDENTIFIER: 12,
    INVALID_CSTA_CONNECTION_IDENTIFIER: 13,
    INVALID_DESTINATION: 14,
    INVALID_FEATURE: 15,
    INVALID_ALLOCATION_STATE: 16,
    INVALID_CROSS_REF_ID: 17,
    INVALID_OBJECT_TYPE: 18,
    SECURITY_VIOLATION: 19,
    GENERIC_STATE_INCOMPATIBILITY: 21,
    INVALID_OBJECT_STATE: 22,
    INVALID_CONNECTION_ID_FOR_ACTIVE_CALL: 23,
    NO_ACTIVE_CALL: 24,
    NO_HELD_CALL: 25,
    NO_CALL_TO_CLEAR: 26,
    NO_CONNECTION_TO_CLEAR: 27,
    NO_CALL_TO_ANSWER: 28,
    NO_CALL_TO_COMPLETE: 29,
    GENERIC_SYSTEM_RESOURCE_AVAILABILITY: 31,
    SERVICE_BUSY: 32,
    RESOURCE_BUSY: 33,
    RESOURCE_OUT_OF_SERVICE: 34,
    NETWORK_BUSY: 35,
    NETWORK_OUT_OF_SERVICE: 36,
    OVERALL_MONITOR_LIMIT_EXCEEDED: 37,
    CONFERENCE_MEMBER_LIMIT_EXCEEDED: 38,
    GENERIC_SUBSCRIBED_RESOURCE_AVAILABILITY: 41,
    OBJECT_MONITOR_LIMIT_EXCEEDED: 42,
    EXTERNAL_TRUNK_LIMIT_EXCEEDED: 43,
    OUTSTANDING_REQUEST_LIMIT_EXCEEDED: 44,
    GENERIC_PERFORMANCE_MANAGEMENT: 51,
    PERFORMANCE_LIMIT_EXCEEDED: 52,
    UNSPECIFIED_SECURITY_ERROR: 60,
    SEQUENCE_NUMBER_VIOLATED: 61,
    TIME_STAMP_VIOLATED: 62,
    PAC_VIOLATED: 63,
    SEAL_VIOLATED: 64,
    GENERIC_UNSPECIFIED_REJECTION: 70,
    GENERIC_OPERATION_REJECTION: 71,
    DUPLICATE_INVOCATION_REJECTION: 72,
    UNRECOGNIZED_OPERATION_REJECTION: 73,
    MISTYPED_ARGUMENT_REJECTION: 74,
    RESOURCE_LIMITATION_REJECTION: 75,
    ACS_HANDLE_TERMINATION_REJECTION: 76,
    SERVICE_TERMINATION_REJECTION: 77,
    REQUEST_TIMEOUT_REJECTION: 78,
    REQUESTS_ON_DEVICE_EXCEEDED_REJECTION: 79,
    UNRECOGNIZED_APDU_REJECTION: 80,
    MISTYPED_APDU_REJECTION: 81,
    BADLY_STRUCTURED_APDU_REJECTION: 82,
    INITIATOR_RELEASING_REJECTION: 83,
    UNRECOGNIZED_LINKEDID_REJECTION: 84,
    LINKED_RESPONSE_UNEXPECTED_REJECTION: 85,
    UNEXPECTED_CHILD_OPERATION_REJECTION: 86,
    MISTYPED_RESULT_REJECTION: 87,
    UNRECOGNIZED_ERROR_REJECTION: 88,
    UNEXPECTED_ERROR_REJECTION: 89,
    MISTYPED_PARAMETER_REJECTION: 90,
    NON_STANDARD: 100
  },

  CSTAEventCause: {
    EC_NONE: -1,
    EC_ACTIVE_MONITOR: 1,
    EC_ALTERNATE: 2,
    EC_BUSY: 3,
    EC_CALL_BACK: 4,
    EC_CALL_CANCELLED: 5,
    EC_CALL_FORWARD_ALWAYS: 6,
    EC_CALL_FORWARD_BUSY: 7,
    EC_CALL_FORWARD_NO_ANSWER: 8,
    EC_CALL_FORWARD: 9,
    EC_CALL_NOT_ANSWERED: 10,
    EC_CALL_PICKUP: 11,
    EC_CAMP_ON: 12,
    EC_DEST_NOT_OBTAINABLE: 13,
    EC_DO_NOT_DISTURB: 14,
    EC_INCOMPATIBLE_DESTINATION: 15,
    EC_INVALID_ACCOUNT_CODE: 16,
    EC_KEY_CONFERENCE: 17,
    EC_LOCKOUT: 18,
    EC_MAINTENANCE: 19,
    EC_NETWORK_CONGESTION: 20,
    EC_NETWORK_NOT_OBTAINABLE: 21,
    EC_NEW_CALL: 22,
    EC_NO_AVAILABLE_AGENTS: 23,
    EC_OVERRIDE: 24,
    EC_PARK: 25,
    EC_OVERFLOW: 26,
    EC_RECALL: 27,
    EC_REDIRECTED: 28,
    EC_REORDER_TONE: 29,
    EC_RESOURCES_NOT_AVAILABLE: 30,
    EC_SILENT_MONITOR: 31,
    EC_TRANSFER: 32,
    EC_TRUNKS_BUSY: 33,
    EC_VOICE_UNIT_INITIATOR: 34
  },

  // typedef char            DeviceID_t[64];

  // enum
  DeviceIDType: {
    DEVICE_IDENTIFIER: 0,
    IMPLICIT_PUBLIC: 20,
    EXPLICIT_PUBLIC_UNKNOWN: 30,
    EXPLICIT_PUBLIC_INTERNATIONAL: 31,
    EXPLICIT_PUBLIC_NATIONAL: 32,
    EXPLICIT_PUBLIC_NETWORK_SPECIFIC: 33,
    EXPLICIT_PUBLIC_SUBSCRIBER: 34,
    EXPLICIT_PUBLIC_ABBREVIATED: 35,
    IMPLICIT_PRIVATE: 40,
    EXPLICIT_PRIVATE_UNKNOWN: 50,
    EXPLICIT_PRIVATE_LEVEL3_REGIONAL_NUMBER: 51,
    EXPLICIT_PRIVATE_LEVEL2_REGIONAL_NUMBER: 52,
    EXPLICIT_PRIVATE_LEVEL1_REGIONAL_NUMBER: 53,
    EXPLICIT_PRIVATE_PTN_SPECIFIC_NUMBER: 54,
    EXPLICIT_PRIVATE_LOCAL_NUMBER: 55,
    EXPLICIT_PRIVATE_ABBREVIATED: 56,
    OTHER_PLAN: 60,
    TRUNK_IDENTIFIER: 70,
    TRUNK_GROUP_IDENTIFIER: 71
  },

  // enum
  DeviceIDStatus: {
    ID_PROVIDED: 0,
    ID_NOT_KNOWN: 1,
    ID_NOT_REQUIRED: 2
  },

  // enum
  ConnectionID_Device: {
    STATIC_ID: 0,
    DYNAMIC_ID: 1
  },

  // enum
  LocalConnectionState: {
    CS_NONE: -1,
    CS_NULL: 0,
    CS_INITIATE: 1,
    CS_ALERTING: 2,
    CS_CONNECT: 3,
    CS_HOLD: 4,
    CS_QUEUED: 5,
    CS_FAIL: 6
  },

  CF_CALL_CLEARED: 0x8000,
  CF_CONFERENCED: 0x4000,
  CF_CONNECTION_CLEARED: 0x2000,
  CF_DELIVERED: 0x1000,
  CF_DIVERTED: 0x0800,
  CF_ESTABLISHED: 0x0400,
  CF_FAILED: 0x0200,
  CF_HELD: 0x0100,
  CF_NETWORK_REACHED: 0x0080,
  CF_ORIGINATED: 0x0040,
  CF_QUEUED: 0x0020,
  CF_RETRIEVED: 0x0010,
  CF_SERVICE_INITIATED: 0x0008,
  CF_TRANSFERRED: 0x0004,

  FF_CALL_INFORMATION: 0x80,
  FF_DO_NOT_DISTURB: 0x40,
  FF_FORWARDING: 0x20,
  FF_MESSAGE_WAITING: 0x10,

  AF_LOGGED_ON: 0x80,
  AF_LOGGED_OFF: 0x40,
  AF_NOT_READY: 0x20,
  AF_READY: 0x10,
  AF_WORK_NOT_READY: 0x08,
  AF_WORK_READY: 0x04,

  MF_BACK_IN_SERVICE: 0x80,
  MF_OUT_OF_SERVICE: 0x40,

  // enum
  ForwardingType: {
    FWD_IMMEDIATE: 0,
    FWD_BUSY: 1,
    FWD_NO_ANS: 2,
    FWD_BUSY_INT: 3,
    FWD_BUSY_EXT: 4,
    FWD_NO_ANS_INT: 5,
    FWD_NO_ANS_EXT: 6
  },

  // enum
  SelectValue: {
    SV_NORMAL: 0,
    SV_LEAST_COST: 1,
    SV_EMERGENCY: 2,
    SV_ACD: 3,
    SV_USER_DEFINED: 4
  },

  noListAvailable: -1,
  noCountAvailable: -2,

  // enum
  Feature_t: {
    FT_CAMP_ON: 0,
    FT_CALL_BACK: 1,
    FT_INTRUDE: 2
  },

  // enum
  AllocationState: {
    AS_CALL_DELIVERED: 0,
    AS_CALL_ESTABLISHED: 1
  },

  // enum
  AgentState: {
    AG_NOT_READY: 0,
    AG_NULL: 1,
    AG_READY: 2,
    AG_WORK_NOT_READY: 3,
    AG_WORK_READY: 4
  },

  // enum
  DeviceType: {
    DT_STATION: 0,
    DT_LINE: 1,
    DT_BUTTON: 2,
    DT_ACD: 3,
    DT_TRUNK: 4,
    DT_OPERATOR: 5,
    DT_STATION_GROUP: 16,
    DT_LINE_GROUP: 17,
    DT_BUTTON_GROUP: 18,
    DT_ACD_GROUP: 19,
    DT_TRUNK_GROUP: 20,
    DT_OPERATOR_GROUP: 21,
    DT_OTHER: 255
  },

  DC_VOICE: 0x80,
  DC_DATA: 0x40,
  DC_IMAGE: 0x20,
  DC_OTHER: 0x10,

  // enum
  AgentMode: {
    AM_LOG_IN: 0, // 로그인
    AM_LOG_OUT: 1, // 로그아웃
    AM_NOT_READY: 2, // 비업무
    AM_READY: 3, // 대기
    AM_WORK_NOT_READY: 4, // 후처리
    AM_WORK_READY: 5
  },

  // enum
  SystemStatus: {
    SS_INITIALIZING: 0,
    SS_ENABLED: 1,
    SS_NORMAL: 2,
    SS_MESSAGES_LOST: 3,
    SS_DISABLED: 4,
    SS_OVERLOAD_IMMINENT: 5,
    SS_OVERLOAD_REACHED: 6,
    SS_OVERLOAD_RELIEVED: 7
  },

  SF_INITIALIZING: 0x80,
  SF_ENABLED: 0x40,
  SF_NORMAL: 0x20,
  SF_MESSAGES_LOST: 0x10,
  SF_DISABLED: 0x08,
  SF_OVERLOAD_IMMINENT: 0x04,
  SF_OVERLOAD_REACHED: 0x02,
  SF_OVERLOAD_RELIEVED: 0x01,

  // enum
  CSTALevel: {
    CSTA_HOME_WORK_TOP: 1,
    CSTA_AWAY_WORK_TOP: 2,
    CSTA_DEVICE_DEVICE_MONITOR: 3,
    CSTA_CALL_DEVICE_MONITOR: 4,
    CSTA_CALL_CONTROL: 5,
    CSTA_ROUTING: 6,
    CSTA_CALL_CALL_MONITOR: 7
  },

  // enum
  SDBLevel: {
    NO_SDB_CHECKING: -1,
    ACS_ONLY: 1,
    ACS_AND_CSTA_CHECKING: 0
  },

  ExtendedDeviceID,
  ConnectionID,
  Connection,
  ConnectionList,
  CSTAMonitorFilter,
  CSTACallState,
  CSTASnapshotDeviceResponseInfo,
  CSTASnapshotDeviceData,
  CSTASnapshotCallResponseInfo,
  CSTASnapshotCallData,
  ForwardingInfo,
  ListForwardParameters,
  SetUpValues,
  CSTAAlternateCall,
  CSTAAlternateCallConfEvent,
  CSTAAnswerCall,
  CSTAAnswerCallConfEvent,
  CSTACallCompletion,
  CSTACallCompletionConfEvent,
  CSTAClearCall,
  CSTAClearCallConfEvent,
  CSTAClearConnection,
  CSTAClearConnectionConfEvent,
  CSTAConferenceCall,
  CSTAConferenceCallConfEvent,
  CSTAConsultationCall,
  CSTAConsultationCallConfEvent,
  CSTADeflectCall,
  CSTADeflectCallConfEvent,
  CSTAPickupCall,
  CSTAPickupCallConfEvent,
  CSTAGroupPickupCall,
  CSTAGroupPickupCallConfEvent,
  CSTAHoldCall,
  CSTAHoldCallConfEvent,
  CSTAMakeCall,
  CSTAMakeCallConfEvent,
  CSTAMakePredictiveCall,
  CSTAMakePredictiveCallConfEvent,
  CSTAQueryMwi,
  CSTAQueryMwiConfEvent,
  CSTAQueryDnd,
  CSTAQueryDndConfEvent,
  CSTAQueryFwd,
  CSTAQueryFwdConfEvent,
  CSTAQueryAgentState,
  CSTAQueryAgentStateConfEvent,
  CSTAQueryLastNumber,
  CSTAQueryLastNumberConfEvent,
  CSTAQueryDeviceInfo,
  CSTAQueryDeviceInfoConfEvent,
  CSTAReconnectCall,
  CSTAReconnectCallConfEvent,
  CSTARetrieveCall,
  CSTARetrieveCallConfEvent,
  CSTASetMwi,
  CSTASetMwiConfEvent,
  CSTASetDnd,
  CSTASetDndConfEvent,
  CSTASetFwd,
  CSTASetFwdConfEvent,
  CSTASetAgentState,
  CSTASetAgentStateConfEvent,
  CSTATransferCall,
  CSTATransferCallConfEvent,
  CSTAUniversalFailureConfEvent,
  CSTACallClearedEvent,
  CSTAConferencedEvent,
  CSTAConnectionClearedEvent,
  CSTADeliveredEvent,
  CSTADivertedEvent,
  CSTAEstablishedEvent,
  CSTAFailedEvent,
  // TODO CSTAHeldEvent CHECK
  // CSTAHeldEvent,
  CSTANetworkReachedEvent,
  CSTAOriginatedEvent,
  CSTAQueuedEvent,
  CSTARetrievedEvent,
  CSTAServiceInitiatedEvent,
  CSTATransferredEvent,
  CSTACallInformationEvent,
  CSTADoNotDisturbEvent,
  CSTAForwardingEvent,
  CSTAMessageWaitingEvent,
  CSTALoggedOnEvent,
  CSTALoggedOffEvent,
  CSTANotReadyEvent,
  CSTAReadyEvent,
  CSTAWorkNotReadyEvent,
  CSTAWorkReadyEvent,
  CSTARouteRegisterReq,
  CSTARouteRegisterReqConfEvent,
  CSTARouteRegisterCancel,
  CSTARouteRegisterCancelConfEvent,
  CSTARouteRegisterAbortEvent,
  CSTARouteRequestEvent,
  CSTARouteSelectInvRequest,
  CSTAReRouteRequest,
  CSTARouteUsedEvent,
  CSTARouteEndEvent,
  CSTARouteEndInvRequest,
  CSTAEscapeSvc,
  CSTAEscapeSvcConfEvent,
  CSTAEscapeSvcReqEvent,
  CSTAEscapeSvcReqConf,
  CSTAPrivateEvent,
  CSTAPrivateStatusEvent,
  CSTASendPrivateEvent,
  CSTABackInServiceEvent,
  CSTAOutOfServiceEvent,
  CSTAReqSysStat,
  CSTASysStatReqConfEvent,
  CSTASysStatStart,
  CSTASysStatStartConfEvent,
  CSTASysStatStop,
  CSTASysStatStopConfEvent,
  CSTAChangeSysStatFilter,
  CSTAChangeSysStatFilterConfEvent,
  CSTASysStatEvent,
  CSTASysStatEndedEvent,
  CSTASysStatReqEvent,
  CSTAReqSysStatConf,
  CSTASysStatEventSend,
  CSTAMonitorDevice,
  CSTAMonitorCall,
  // TODO CHECK CSTAMonitorCallsViaDevice
  // CSTAMonitorCallsViaDevice,
  CSTAMonitorConfEvent,
  CSTAChangeMonitorFilter,
  CSTAChangeMonitorFilterConfEvent,
  CSTAMonitorStop,
  CSTAMonitorStopConfEvent,
  CSTAMonitorEndedEvent,
  CSTASnapshotCall,
  CSTASnapshotCallConfEvent,
  CSTASnapshotDevice,
  CSTASnapshotDeviceConfEvent,
  CSTAGetAPICaps,
  CSTAGetAPICapsConfEvent,
  CSTAGetDeviceList,
  CSTAGetDeviceListConfEvent,
  CSTAQueryCallMonitor,
  CSTAQueryCallMonitorConfEvent,
  CSTARouteRequestExtEvent,
  CSTARouteUsedExtEvent
};

var CallingDeviceID = ExtendedDeviceID;
var CalledDeviceID = ExtendedDeviceID;
var SubjectDeviceID = ExtendedDeviceID;
var RedirectionDeviceID = ExtendedDeviceID;

var AccountInfo = new ArrayBuffer(32);
var AgentID = new ArrayBuffer(32);
// typedef DeviceID_t AgentGroup_t;
var AgentPassword = new ArrayBuffer(32);
var AuthCode = new ArrayBuffer(32);

function ExtendedDeviceID() {
  // size : 72
  this.deviceID = 0; // AgentGroup_t  <- char[64]
  this.deviceIDType = this.DeviceIDType; // new DeviceIDType_t()
  this.deviceIDStatus = this.DeviceIDStatus; // new DeviceIDStatus_t()
}

function ConnectionID() {
  // size : 72
  this.callID = 0; // long
  this.deviceID = 0; // AgentGroup_t  <- char[64]
  this.devIDType = this.ConnectionID_Device;
}

function Connection() {
  this.party = new ConnectionID();
  this.staticDevice = new SubjectDeviceID();
}

function ConnectionList() {
  this.count = 0; // _Int
  this.connection = new Connection();
}

function CSTAMonitorFilter() {
  this.call = 0; /* CSTACallFilter_t unsigned short */
  this.feature = 0; /* CSTAFeatureFilter_t unsigned char */
  this.agent = 0; /* CSTAAgentFilter_t unsigned char */
  this.maintenance = 0; /* CSTAMaintenanceFilter_t  unsigned char */
  this.privateFilter = 0; // long
}

function CSTACallState() {
  this.count = 0; // _Int
  this.state = this.LocalConnectionState; // LocalConnectionState_t()()()
}

function CSTASnapshotDeviceResponseInfo() {
  this.callIdentifier = new ConnectionID();
  this.localCallState = new CSTACallState();
}

function CSTASnapshotDeviceData() {
  this.count = 0; // _Int
  this.info = new CSTASnapshotDeviceResponseInfo();
}

function CSTASnapshotCallResponseInfo() {
  this.deviceOnCall = new SubjectDeviceID();
  this.callIdentifier = new ConnectionID();
  this.localConnectionState = this.LocalConnectionState; // LocalConnectionState_t()()
}

function CSTASnapshotCallData() {
  this.count = 0; // _Int
  this.info = new CSTASnapshotCallResponseInfo();
}

function ForwardingInfo() {
  this.forwardingType = this.ForwardingType;
  this.forwardingOn = 0; // Boolean
  this.forwardDN = 0; // AgentGroup_t  <- char[64]
}

function ListForwardParameters() {
  this.count = 0; // short
  this.param = new ForwardingInfo(); // [7]
}

function SetUpValues() {
  this.length = 0; // _Int
  this.value = 0; // unsigned char
}

function CSTAAlternateCall() {
  this.activeCall = new ConnectionID();
  this.otherCall = new ConnectionID();
}

function CSTAAlternateCallConfEvent() {
  this.Nulltype = 0; // null
}

function CSTAAnswerCall() {
  this.alertingCall = new ConnectionID();
}

function CSTAAnswerCallConfEvent() {
  this.Nulltype = 0; // null
}

function CSTACallCompletion() {
  this.feature = this.Feature_t;
  this.call = new ConnectionID();
}

function CSTACallCompletionConfEvent() {
  this.Nulltype = 0; // null
}

function CSTAClearCall() {
  this.call = new ConnectionID();
}

function CSTAClearCallConfEvent() {
  this.Nulltype = 0; // null
}

function CSTAClearConnection() {
  this.call = new ConnectionID();
}

function CSTAClearConnectionConfEvent() {
  this.Nulltype = 0; // null
}

function CSTAConferenceCall() {
  this.heldCall = new ConnectionID();
  this.activeCall = new ConnectionID();
}

function CSTAConferenceCallConfEvent() {
  this.newCall = new ConnectionID();
  this.connList = new ConnectionList();
}

function CSTAConsultationCall() {
  this.activeCall = new ConnectionID();
  this.calledDevice = 0; // AgentGroup_t  <- char[64]
}

function CSTAConsultationCallConfEvent() {
  this.newCall = new ConnectionID();
}

function CSTADeflectCall() {
  this.deflectCall = new ConnectionID();
  this.calledDevice = 0; // AgentGroup_t  <- char[64]
}

function CSTADeflectCallConfEvent() {
  this.Nulltype = 0; // null
}

function CSTAPickupCall() {
  this.deflectCall = new ConnectionID();
  this.calledDevice = 0; // AgentGroup_t  <- char[64]
}

function CSTAPickupCallConfEvent() {
  this.Nulltype = 0; // null
}

function CSTAGroupPickupCall() {
  this.deflectCall = new ConnectionID();
  this.pickupDevice = 0; // AgentGroup_t  <- char[64]
}

function CSTAGroupPickupCallConfEvent() {
  this.Nulltype = 0; // null
}

function CSTAHoldCall() {
  this.activeCall = new ConnectionID();
  this.reservation = 0; // Boolean
}

function CSTAHoldCallConfEvent() {
  this.Nulltype = 0; // null
}

function CSTAMakeCall() {
  this.callingDevice = 0; // AgentGroup_t  <- char[64]
  this.calledDevice = 0; // AgentGroup_t  <- char[64]
}

function CSTAMakeCallConfEvent() {
  this.newCall = new ConnectionID();
}

function CSTAMakePredictiveCall() {
  this.callingDevice = 0; // AgentGroup_t  <- char[64]
  this.calledDevice = 0; // AgentGroup_t  <- char[64]
  this.allocationState = this.AllocationState;
}

function CSTAMakePredictiveCallConfEvent() {
  this.newCall = new ConnectionID();
}

function CSTAQueryMwi() {
  this.device = 0; // AgentGroup_t  <- char[64]
}

function CSTAQueryMwiConfEvent() {
  this.messages = 0; // Boolean
}

function CSTAQueryDnd() {
  this.device = 0; // AgentGroup_t  <- char[64]
}

function CSTAQueryDndConfEvent() {
  this.doNotDisturb = 0; // Boolean
}

function CSTAQueryFwd() {
  this.device = 0; // AgentGroup_t  <- char[64]
}

function CSTAQueryFwdConfEvent() {
  this.forward = new ListForwardParameters();
}

function CSTAQueryAgentState() {
  this.device = 0; // AgentGroup_t  <- char[64]
}

function CSTAQueryAgentStateConfEvent() {
  this.agentState = this.AgentState;
}

function CSTAQueryLastNumber() {
  this.device = 0; // AgentGroup_t  <- char[64]
}

function CSTAQueryLastNumberConfEvent() {
  this.lastNumber = 0; // AgentGroup_t  <- char[64]
}

function CSTAQueryDeviceInfo() {
  this.device = 0; // AgentGroup_t  <- char[64]
}

function CSTAQueryDeviceInfoConfEvent() {
  this.device = 0; // AgentGroup_t  <- char[64]
  this.deviceType = this.DeviceType;
  this.deviceClass = 0; /* DeviceClass_t  unsigned char */
}

function CSTAReconnectCall() {
  this.activeCall = new ConnectionID();
  this.heldCall = new ConnectionID();
}

function CSTAReconnectCallConfEvent() {
  this.Nulltype = 0; // null
}

function CSTARetrieveCall() {
  this.heldCall = new ConnectionID();
}

function CSTARetrieveCallConfEvent() {
  this.Nulltype = 0; // null
}

function CSTASetMwi() {
  this.device = 0; // AgentGroup_t  <- char[64]
  this.messages = 0; // Boolean
}

function CSTASetMwiConfEvent() {
  this.Nulltype = 0; // null
}

function CSTASetDnd() {
  this.device = 0; // AgentGroup_t  <- char[64]
  this.doNotDisturb = 0; // Boolean
}

function CSTASetDndConfEvent() {
  this.Nulltype = 0; // null
}

function CSTASetFwd() {
  this.device = 0; // AgentGroup_t  <- char[64]
  this.forward = new ForwardingInfo();
}

function CSTASetFwdConfEvent() {
  this.Nulltype = 0; // null
}

function CSTASetAgentState() {
  this.device = 0; // AgentGroup_t  <- char[64]
  this.agentMode = this.AgentMode;
  this.agentID = new AgentID();
  this.agentGroup = 0; // AgentGroup_t  <- char[64]
  this.agentPassword = new AgentPassword();
}

function CSTASetAgentStateConfEvent() {
  this.Nulltype = 0; // null
}

function CSTATransferCall() {
  this.heldCall = new ConnectionID();
  this.activeCall = new ConnectionID();
}

function CSTATransferCallConfEvent() {
  this.newCall = new ConnectionID();
  this.connList = new ConnectionList();
}

function CSTAUniversalFailureConfEvent() {
  this.error = this.CSTAUniversalFailure; // new CSTAUniversalFailure_t()()
}

function CSTACallClearedEvent() {
  this.clearedCall = new ConnectionID();
  this.localConnectionInfo = this.LocalConnectionState; // LocalConnectionState_t()()()
  this.cause = this.CSTAEventCause;
}

function CSTAConferencedEvent() {
  this.primaryOldCall = new ConnectionID();
  this.secondaryOldCall = new ConnectionID();
  this.confController = new SubjectDeviceID();
  this.addedParty = new SubjectDeviceID();
  this.conferenceConnections = new ConnectionList();
  this.localConnectionInfo = this.LocalConnectionState; // LocalConnectionState_t()()
  this.cause = this.CSTAEventCause;
}

function CSTAConnectionClearedEvent() {
  this.droppedConnection = new ConnectionID();
  this.releasingDevice = new SubjectDeviceID();
  this.localConnectionInfo = this.LocalConnectionState; // LocalConnectionState_t()()
  this.cause = this.CSTAEventCause;
}

function CSTADeliveredEvent() {
  this.connection = new ConnectionID();
  this.alertingDevice = new SubjectDeviceID();
  this.callingDevice = new CallingDeviceID();
  this.calledDevice = new CalledDeviceID();
  this.lastRedirectionDevice = new RedirectionDeviceID();
  this.localConnectionInfo = this.LocalConnectionState; // LocalConnectionState_t()()
  this.cause = this.CSTAEventCause;
}

function CSTADivertedEvent() {
  this.connection = new ConnectionID();
  this.divertingDevice = new SubjectDeviceID();
  this.newDestination = new CalledDeviceID();
  this.localConnectionInfo = this.LocalConnectionState; // LocalConnectionState_t()()
  this.cause = this.CSTAEventCause;
}

function CSTAEstablishedEvent() {
  this.establishedConnection = new ConnectionID();
  this.answeringDevice = new SubjectDeviceID();
  this.callingDevice = new CallingDeviceID();
  this.calledDevice = new CalledDeviceID();
  this.lastRedirectionDevice = new RedirectionDeviceID();
  this.localConnectionInfo = this.LocalConnectionState; // LocalConnectionState_t()()
  this.cause = this.CSTAEventCause;
}

function CSTAFailedEvent() {
  this.failedConnection = new ConnectionID();
  this.failingDevice = new SubjectDeviceID();
  this.calledDevice = new CalledDeviceID();
  this.localConnectionInfo = this.LocalConnectionState; // LocalConnectionState_t()()
  this.cause = this.CSTAEventCause;
}

// TODO CSTAHeldEvent CHECK
// function CSTAHeldEvent () {
//   heldConnection = new ConnectionID()
//   holdingDevice = new SubjectDeviceID()
//   localConnectionInfo = this.LocalConnectionState // LocalConnectionState_t()()
//   cause = this.CSTAEventCause
// }

function CSTANetworkReachedEvent() {
  this.connection = new ConnectionID();
  this.trunkUsed = new SubjectDeviceID();
  this.calledDevice = new CalledDeviceID();
  this.localConnectionInfo = this.LocalConnectionState; // LocalConnectionState_t()()
  this.cause = this.CSTAEventCause;
}

function CSTAOriginatedEvent() {
  this.originatedConnection = new ConnectionID();
  this.callingDevice = new SubjectDeviceID();
  this.calledDevice = new CalledDeviceID();
  this.localConnectionInfo = this.LocalConnectionState; // LocalConnectionState_t()()
  this.cause = this.CSTAEventCause;
}

function CSTAQueuedEvent() {
  this.queuedConnection = new ConnectionID();
  this.queue = new SubjectDeviceID();
  this.callingDevice = new CallingDeviceID();
  this.calledDevice = new CalledDeviceID();
  this.lastRedirectionDevice = new RedirectionDeviceID();
  this.numberQueued = 0; // short
  this.localConnectionInfo = this.LocalConnectionState; // LocalConnectionState_t()()
  this.cause = this.CSTAEventCause;
}

function CSTARetrievedEvent() {
  this.retrievedConnection = new ConnectionID();
  this.retrievingDevice = new SubjectDeviceID();
  this.localConnectionInfo = this.LocalConnectionState; // LocalConnectionState_t()()
  this.cause = this.CSTAEventCause;
}

function CSTAServiceInitiatedEvent() {
  this.initiatedConnection = new ConnectionID();
  this.localConnectionInfo = this.LocalConnectionState; // LocalConnectionState_t()()
  this.cause = this.CSTAEventCause;
}

function CSTATransferredEvent() {
  this.primaryOldCall = new ConnectionID();
  this.secondaryOldCall = new ConnectionID();
  this.transferringDevice = new SubjectDeviceID();
  this.transferredDevice = new SubjectDeviceID();
  this.transferredConnections = new ConnectionList();
  this.localConnectionInfo = this.LocalConnectionState; // LocalConnectionState_t()()
  this.cause = this.CSTAEventCause;
}

function CSTACallInformationEvent() {
  this.connection = new ConnectionID();
  this.device = new SubjectDeviceID();
  this.accountInfo = new AccountInfo();
  this.authorisationCode = new AuthCode();
}

function CSTADoNotDisturbEvent() {
  this.device = new SubjectDeviceID();
  this.doNotDisturbOn = 0; // Boolean
}

function CSTAForwardingEvent() {
  this.device = new SubjectDeviceID();
  this.forwardingInformation = new ForwardingInfo();
}

function CSTAMessageWaitingEvent() {
  this.deviceForMessage = new CalledDeviceID();
  this.invokingDevice = new SubjectDeviceID();
  this.messageWaitingOn = 0; // Boolean
}

function CSTALoggedOnEvent() {
  this.agentDevice = new SubjectDeviceID();
  this.agentID = new AgentID();
  this.agentGroup = 0; // AgentGroup_t  <- char[64]
  this.password = new AgentPassword();
}

function CSTALoggedOffEvent() {
  this.agentDevice = new SubjectDeviceID();
  this.agentID = new AgentID();
  this.agentGroup = 0; // AgentGroup_t  <- char[64]
}

function CSTANotReadyEvent() {
  this.agentDevice = new SubjectDeviceID();
  this.agentID = new AgentID();
}

function CSTAReadyEvent() {
  this.agentDevice = new SubjectDeviceID();
  this.agentID = new AgentID();
}

function CSTAWorkNotReadyEvent() {
  this.agentDevice = new SubjectDeviceID();
  this.agentID = new AgentID();
}

function CSTAWorkReadyEvent() {
  this.agentDevice = new SubjectDeviceID();
  this.agentID = new AgentID();
}

function CSTARouteRegisterReq() {
  this.routingDevice = 0; // AgentGroup_t  <- char[64]
}

function CSTARouteRegisterReqConfEvent() {
  this.registerReqID = 0; /* RoutingCrossRefID_t   long */
}

function CSTARouteRegisterCancel() {
  this.routeRegisterReqID = 0; /* RoutingCrossRefID_t   long */
}

function CSTARouteRegisterCancelConfEvent() {
  this.routeRegisterReqID = 0; /* RoutingCrossRefID_t   long */
}

function CSTARouteRegisterAbortEvent() {
  this.routeRegisterReqID = 0; /* RoutingCrossRefID_t   long */
}

function CSTARouteRequestEvent() {
  this.routeRegisterReqID = 0; /* RoutingCrossRefID_t   long */
  this.routingCrossRefID = 0; /* RoutingCrossRefID_t   long */
  this.currentRoute = 0; // AgentGroup_t  <- char[64]
  this.callingDevice = 0; // AgentGroup_t  <- char[64]
  this.routedCall = new ConnectionID();
  this.routedSelAlgorithm = this.SelectValue;
  this.priority = 0; // Boolean
  this.setupInformation = new SetUpValues();
}

function CSTARouteSelectInvRequest() {
  // CSTARouteSelectRequest_t() {
  this.routeRegisterReqID = 0; /* RoutingCrossRefID_t   long */
  this.routingCrossRefID = 0; /* RoutingCrossRefID_t   long */
  this.routeSelected = 0; // AgentGroup_t  <- char[64]
  this.remainRetry = 0; /* RetryValue_t   short */
  this.setupInformation = new SetUpValues();
  this.routeUsedReq = 0; // Boolean
}

function CSTAReRouteRequest() {
  this.routeRegisterReqID = 0; /* RoutingCrossRefID_t   long */
  this.routingCrossRefID = 0; /* RoutingCrossRefID_t   long */
}

function CSTARouteUsedEvent() {
  this.routeRegisterReqID = 0; /* RoutingCrossRefID_t   long */
  this.routingCrossRefID = 0; /* RoutingCrossRefID_t   long */
  this.routeUsed = 0; // AgentGroup_t  <- char[64]
  this.callingDevice = 0; // AgentGroup_t  <- char[64]
  this.domain = 0; // Boolean
}

function CSTARouteEndEvent() {
  this.routeRegisterReqID = 0; /* RoutingCrossRefID_t   long */
  this.routingCrossRefID = 0; /* RoutingCrossRefID_t   long */
  this.errorValue = this.CSTAUniversalFailure; // new CSTAUniversalFailure_t()()
}

function CSTARouteEndInvRequest() {
  // CSTARouteEndRequest_t() {
  this.routeRegisterReqID = 0; /* RoutingCrossRefID_t   long */
  this.routingCrossRefID = 0; /* RoutingCrossRefID_t   long */
  this.errorValue = this.CSTAUniversalFailure; // new CSTAUniversalFailure_t()()
}

function CSTAEscapeSvc() {
  this.Nulltype = 0; // null
}

function CSTAEscapeSvcConfEvent() {
  this.Nulltype = 0; // null
}

function CSTAEscapeSvcReqEvent() {
  this.Nulltype = 0; // null
}

function CSTAEscapeSvcReqConf() {
  this.errorValue = this.CSTAUniversalFailure; // new CSTAUniversalFailure_t()()
}

function CSTAPrivateEvent() {
  this.Nulltype = 0; // null
}

function CSTAPrivateStatusEvent() {
  this.Nulltype = 0; // null
}

function CSTASendPrivateEvent() {
  this.Nulltype = 0; // null
}

function CSTABackInServiceEvent() {
  this.device = 0; // AgentGroup_t  <- char[64]
  this.cause = this.CSTAEventCause;
}

function CSTAOutOfServiceEvent() {
  this.device = 0; // AgentGroup_t  <- char[64]
  this.cause = this.CSTAEventCause;
}

function CSTAReqSysStat() {
  this.Nulltype = 0; // null
}

function CSTASysStatReqConfEvent() {
  this.systemStatus = this.SystemStatus;
}

function CSTASysStatStart() {
  this.statusFilter = 0; /* SystemStatusFilter_t   unsigned char */
}

function CSTASysStatStartConfEvent() {
  this.statusFilter = 0; /* SystemStatusFilter_t   unsigned char */
}

function CSTASysStatStop() {
  this.Nulltype = 0; // null
}

function CSTASysStatStopConfEvent() {
  this.Nulltype = 0; // null
}

function CSTAChangeSysStatFilter() {
  this.statusFilter = 0; /* SystemStatusFilter_t   unsigned char */
}

function CSTAChangeSysStatFilterConfEvent() {
  this.statusFilterSelected = 0; /* SystemStatusFilter_t   unsigned char */
  this.statusFilterActive = 0; /* SystemStatusFilter_t   unsigned char */
}

function CSTASysStatEvent() {
  this.systemStatus = this.SystemStatus;
}

function CSTASysStatEndedEvent() {
  this.Nulltype = 0; // null
}

function CSTASysStatReqEvent() {
  this.Nulltype = 0; // null
}

function CSTAReqSysStatConf() {
  this.systemStatus = this.SystemStatus;
}

function CSTASysStatEventSend() {
  this.systemStatus = this.SystemStatus;
}

function CSTAMonitorDevice() {
  this.deviceID = 0; // AgentGroup_t  <- char[64]
  this.monitorFilter = new CSTAMonitorFilter();
}

function CSTAMonitorCall() {
  this.call = new ConnectionID();
  this.monitorFilter = new CSTAMonitorFilter();
}

// TODO CHECK CSTAMonitorCallsViaDevice
// function CSTAMonitorCallsViaDevice () {
//   this.deviceID = new AgentGroup_t()
//   this.monitorFilter = new CSTAMonitorFilter()
// }

function CSTAMonitorConfEvent() {
  this.monitorCrossRefID = 0; /* CSTAMonitorCrossRefID_t long */
  this.monitorFilter = new CSTAMonitorFilter();
}

function CSTAChangeMonitorFilter() {
  this.monitorCrossRefID = 0; /* CSTAMonitorCrossRefID_t long */
  this.monitorFilter = new CSTAMonitorFilter();
}

function CSTAChangeMonitorFilterConfEvent() {
  this.monitorFilter = new CSTAMonitorFilter();
}

function CSTAMonitorStop() {
  this.thismonitorCrossRefID = 0; /* CSTAMonitorCrossRefID_t long */
}

function CSTAMonitorStopConfEvent() {
  this.Nulltype = 0; // null
}

function CSTAMonitorEndedEvent() {
  this.cause = this.CSTAEventCause;
}

function CSTASnapshotCall() {
  this.snapshotObject = new ConnectionID();
}

function CSTASnapshotCallConfEvent() {
  this.snapshotData = new CSTASnapshotCallData();
}

function CSTASnapshotDevice() {
  this.snapshotObject = 0; // AgentGroup_t  <- char[64]
}

function CSTASnapshotDeviceConfEvent() {
  this.snapshotData = new CSTASnapshotDeviceData();
}

function CSTAGetAPICaps() {
  this.Nulltype = 0; // null
}

function CSTAGetAPICapsConfEvent() {
  this.alternateCall = 0; // short
  this.answerCall = 0; // short
  this.callCompletion = 0; // short
  this.clearCall = 0; // short
  this.clearConnection = 0; // short
  this.conferenceCall = 0; // short
  this.consultationCall = 0; // short
  this.deflectCall = 0; // short
  this.pickupCall = 0; // short
  this.groupPickupCall = 0; // short
  this.holdCall = 0; // short
  this.makeCall = 0; // short
  this.makePredictiveCall = 0; // short
  this.queryMwi = 0; // short
  this.queryDnd = 0; // short
  this.queryFwd = 0; // short
  this.queryAgentState = 0; // short
  this.queryLastNumber = 0; // short
  this.queryDeviceInfo = 0; // short
  this.reconnectCall = 0; // short
  this.retrieveCall = 0; // short
  this.setMwi = 0; // short
  this.setDnd = 0; // short
  this.setFwd = 0; // short
  this.setAgentState = 0; // short
  this.transferCall = 0; // short
  this.eventReport = 0; // short
  this.callClearedEvent = 0; // short
  this.conferencedEvent = 0; // short
  this.connectionClearedEvent = 0; // short
  this.deliveredEvent = 0; // short
  this.divertedEvent = 0; // short
  this.establishedEvent = 0; // short
  this.failedEvent = 0; // short
  this.heldEvent = 0; // short
  this.networkReachedEvent = 0; // short
  this.originatedEvent = 0; // short
  this.queuedEvent = 0; // short
  this.retrievedEvent = 0; // short
  this.serviceInitiatedEvent = 0; // short
  this.transferredEvent = 0; // short
  this.callInformationEvent = 0; // short
  this.doNotDisturbEvent = 0; // short
  this.forwardingEvent = 0; // short
  this.messageWaitingEvent = 0; // short
  this.loggedOnEvent = 0; // short
  this.loggedOffEvent = 0; // short
  this.notReadyEvent = 0; // short
  this.readyEvent = 0; // short
  this.workNotReadyEvent = 0; // short
  this.workReadyEvent = 0; // short
  this.backInServiceEvent = 0; // short
  this.outOfServiceEvent = 0; // short
  this.privateEvent = 0; // short
  this.routeRequestEvent = 0; // short
  this.reRoute = 0; // short
  this.routeSelect = 0; // short
  this.routeUsedEvent = 0; // short
  this.routeEndEvent = 0; // short
  this.monitorDevice = 0; // short
  this.monitorCall = 0; // short
  this.monitorCallsViaDevice = 0; // short
  this.changeMonitorFilter = 0; // short
  this.monitorStop = 0; // short
  this.monitorEnded = 0; // short
  this.snapshotDeviceReq = 0; // short
  this.snapshotCallReq = 0; // short
  this.escapeService = 0; // short
  this.privateStatusEvent = 0; // short
  this.escapeServiceEvent = 0; // short
  this.escapeServiceConf = 0; // short
  this.sendPrivateEvent = 0; // short
  this.sysStatReq = 0; // short
  this.sysStatStart = 0; // short
  this.sysStatStop = 0; // short
  this.changeSysStatFilter = 0; // short
  this.sysStatReqEvent = 0; // short
  this.sysStatReqConf = 0; // short
  this.sysStatEvent = 0; // short
}

function CSTAGetDeviceList() {
  this.index = 0; // long
  this.level = this.CSTALevel;
}

function DeviceList() {
  this.count = 0; // char
  this.device = 0; // AgentGroup_t[20]
}

function CSTAGetDeviceListConfEvent() {
  this.driverSdbLevel = this.SDBLevel;
  this.level = this.CSTALevel;
  this.index = 0; // long
  this.devList = new DeviceList();
}

function CSTAQueryCallMonitor() {
  this.Nulltype = 0; // null
}

function CSTAQueryCallMonitorConfEvent() {
  this.callMonitor = 0; // Boolean
}

function CSTARouteRequestExtEvent() {
  this.routeRegisterReqID = 0; /* RoutingCrossRefID_t   long */
  this.routingCrossRefID = 0; /* RoutingCrossRefID_t   long */
  this.currentRoute = new CalledDeviceID();
  this.callingDevice = new CallingDeviceID();
  this.routedCall = new ConnectionID();
  this.routedSelAlgorithm = this.SelectValue;
  this.priority = 0; // Boolean
  this.setupInformation = new SetUpValues();
}

function CSTARouteUsedExtEvent() {
  this.routeRegisterReqID = 0; /* RoutingCrossRefID_t   long */
  this.routingCrossRefID = 0; /* RoutingCrossRefID_t   long */
  this.routeUsed = new CalledDeviceID();
  this.callingDevice = new CallingDeviceID();
  this.domain = 0; // Boolean
}

// typedef CSTARouteSelectRequest_t CSTARouteSelectInvRequest_t;

// typedef CSTARouteEndRequest_t CSTARouteEndInvRequest_t;

// extern void *csta_asn_tbl;    /* encoder-decoder control table */



// WEBPACK FOOTER //
// ./src/util/call/neomecca/netDialAPI/cstaDefs.js